<template>
  <footer class="footer-component">
    <h6>© 2019 Hendrik Runte</h6>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
  footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    h6 {
      font-weight: 300;
    }
  }
</style>
